(function( $ ) {
    // the sameHeight functions makes all the selected elements of the same height
    $.fn.sameHeight = function() {
        var maxHeight = 0;
        $('.js-get-height')
            .each(function() { maxHeight = Math.max(maxHeight, $(this).height()); })
            .height(maxHeight);
    };
}( jQuery ));


if ($(window).width() >= 993) {
    $('.js-card-height').sameHeight();

    $(window).resize(function(){
        // Do it when the window resizes too
        $('.js-card-height').sameHeight();

    });
}
else {

}